import styled from 'styled-components'

export const S_ProgressBar = styled.div`
  max-width: ${(props) => props.width};
  position: relative;

  .progress-line {
    position: absolute;
    left: 0;
    top: 0;
  }
`

export const S_Progress = styled.div`
  display: flex;
  align-items: center;

  .italic {
    padding-left: 10px;
    font-style: italic;
  }
`
